import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Header, Icon, Message} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader';
import styled from 'styled-components';
import {GreenButton, DefaultButton, ButtonsGroup} from '../../components/Button/ButtonMix';
import {BlueContainer} from '../../components/Container/ContainerMix';
import {FormInputLogin} from '../../components/Form/FormInputMix';
import {passwordReset} from '../../api';

const StyledForm = styled(Form)`
  padding: 10px 0 10px 0;
`;

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isSubmitted: false,
      email: null
    };
  }
  
  handleChange = (e, {name, value}) => this.setState({[name]: value, isSubmitted: false});
  
  sendPasswordResetEmail = () => {
    const {email} = this.state;
    
    return passwordReset(email)
      .then(() => {
        this.setState({isSubmitted: true});
      });
  };
  
  render() {
    const {router} = this.props;
    const {email, isSubmitted} = this.state;
    
    return (
      <BlueContainer>
        <Header as="h1" icon textAlign="center">
          <Icon name="lock" circular/>
          <Header.Content>Forgot your password?</Header.Content>
          <HeaderSubHeader>Enter the email you used to sign-up for BodyBank</HeaderSubHeader>
        </Header>
        <StyledForm>
          <FormInputLogin fluid value={email} label="Email" type="email" name="email" placeholder="Email" onChange={this.handleChange} required/>
        </StyledForm>
        {isSubmitted && (
          <Message info icon>
            <Icon name="checkmark circle"/>
            <Message.Content>
              <Message.Header>Request received. An email will be sent with password reset instructions.</Message.Header>
            </Message.Content>
          </Message>
        )}
        <ButtonsGroup>
          <DefaultButton onClick={() => router.push('/login')}>Cancel</DefaultButton>
          <GreenButton onClick={this.sendPasswordResetEmail}>Submit</GreenButton>
        </ButtonsGroup>
      </BlueContainer>
    );
  }
}

ForgotPassword.propTypes = {
  router: PropTypes.object.isRequired
};

export default withRouter(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/Login/ForgotPassword.js